import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { BSModal } from "../common";

const Timeout = (props) => {
  return (
    <BSModal
      onClose={props.onClose}
      show={!!props.show}
      className={"warning-modal"}
      title={
        <FormattedMessage id="login.timeout.title">
          {(f) => <span className="icon warning">{f}</span>}
        </FormattedMessage>
      }
    >
      <FormattedMessage id="login.timeout.body" />
    </BSModal>
  );
};

Timeout.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Timeout;



// WEBPACK FOOTER //
// ./src/components/login/Timeout.js